import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface SearchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  value: string;
  onValueChange: (value: string) => void;
  label?: string;
}

export function Search({
  value,
  onValueChange,
  label = "Search",
  className,
  placeholder = "Search",
  id,
  ...rest
}: SearchProps) {
  return (
    <div className={cn(styles.searchWrap, className)}>
      <label className={styles.srOnly} htmlFor={id ?? "hq-search"}>
        {label}
      </label>
      <input
        id={id ?? "hq-search"}
        type="search"
        className={styles.control}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onValueChange(event.target.value)}
        {...rest}
      />
      {value ? (
        <button
          type="button"
          className={styles.searchClear}
          onClick={() => onValueChange("")}
          aria-label="Clear search"
        >
          Clear
        </button>
      ) : null}
    </div>
  );
}
